import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../public/img/profile.svg'


const _hoisted_1 = { class: "max-w-[95vw] sm:max-w-[754px] xl:max-w-[1240px] w-full mx-auto flex flex-col justify-center items-center" }
const _hoisted_2 = { class: "flex lg:flex-row flex-col lg:justify-center justify-center min-h-[90vh] items-center gap-8 space-y-8 md:space-x-8 md:mt-0 mt-12" }
const _hoisted_3 = { class: "lg:w-1/2 w-full lg:text-left text-center flex flex-col lg:justify-start justify-center lg:items-start items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "sm:text-[38px] text-[28px] font-bold text-[#163537] dark:text-gray-200" }, " Hello, I'm Leo ッ ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "sm:text-[54px] text-[28px] font-bold text-[#163537] dark:text-gray-200" }, " Frontend Engineer ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg mt-4 text-[#56555e] dark:text-gray-400" }, " I build engaging and user-friendly web applications using the latest frontend technologies. ", -1)
const _hoisted_7 = { class: "lg:w-1/2 w-full flex lg:justify-end justify-center items-center bounce" }
const _hoisted_8 = {
  key: 0,
  class: "max-w-[370px] max-h-[300px] w-[370px] md:w-[500px]"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#project",
  class: "sm:flex hidden border-2 dark:border-gray-700 rounded-full z-[1] h-14 w-14 -mt-10 justify-center items-center bounce cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://assets-global.website-files.com/60f5a97b9e66c2b92c76a14e/6140a7f1ccfe242db78e97b5_Vector.svg",
    loading: "lazy",
    width: "21",
    alt: ""
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "border dark:border-gray-700 w-full my-4" }, null, -1)
const _hoisted_11 = { class: "relative flex min-h-screen flex-col justify-center overflow-hidden bg-gray-50 dark:bg-gray-900 py-6 sm:py-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "bg-image bg-cover bg-center lg:text-7xl text-4xl font-black text-center lg:mt-4 mb-12 text-[#163537] dark:text-gray-200" }, " What I do? ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", {
  id: "title",
  class: "leo"
}, null, -1)
const _hoisted_14 = { class: "flex flex-col gap-6 lg:flex-row sm:gap-6 sm:justify-center px-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "absolute top-10 z-0 h-20 w-20 rounded-full bg-[#163537] dark:bg-gray-700 transition-all duration-300 group-hover:scale-[10]" }, null, -1)
const _hoisted_16 = { class: "relative z-10 mx-auto max-w-md" }
const _hoisted_17 = { class: "grid h-20 w-20 place-items-center rounded-full bg-[#163537] dark:bg-gray-700 transition-all duration-300 group-hover:border-[#ffeeff] dark:group-hover:border-gray-600 group-hover:border" }
const _hoisted_18 = { class: "pt-5 text-xl font-semibold leading-7" }
const _hoisted_19 = { class: "group-hover:text-white/90 text-gray-900 dark:text-gray-200" }
const _hoisted_20 = { class: "space-y-6 pt-5 text-base leading-7 text-gray-600 dark:text-gray-400 transition-all duration-300 group-hover:text-white/90" }

import AppNavbar from "@/components/AppNavbar.vue";
import AppFooter from "@/components/AppFooter.vue";
import ContactForm from "@/components/ContactForm.vue";
import TechStack from "@/components/TechStack.vue";
import ProjectComp from "@/components/ProjectComp.vue";
import StatisticsComp from "@/components/StatisticsComp.vue";
import TestimonialsComp from "@/components/TestimonialsComp.vue";
import SkeletonLoader from "@/components/SkeletonLoader.vue";
import { onMounted, ref } from "vue";
import CodeIcon from "@/components/IconComp/CodeIcon.vue";
import ItIcon from "@/components/IconComp/ItIcon.vue";
import DesignIcon from "@/components/IconComp/DesignIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const imageLoading = ref(true);

onMounted(() => {
  // Preload profile image
  const img = new Image();
  img.src = "../../public/img/profile.svg";
  img.onload = () => {
    imageLoading.value = false;
  };
  img.onerror = () => {
    imageLoading.value = false;
  };
});

const services = ref([
  {
    id: 1,
    description:
      "I create web applications or websites that are functional, responsive, and user-friendly. Understanding client requirements, developing the necessary features and functionality, and ensuring the site is optimized for performance.",
    title: "Web Design & Development",
    iconComponent: CodeIcon,
  },
  {
    id: 2,
    description:
      "Websites require regular updates and maintenance to stay current and secure. I offer ongoing support to keep your site in top shape, address any issues that arise, and make necessary updates to ensure it continues to meet your evolving needs.",
    title: "Maintenance and Support",
    iconComponent: ItIcon,
  },
  {
    id: 3,
    description:
      "I create visually appealing and intuitive user interfaces. Designing wireframes, prototypes, and mockups, selecting appropriate color schemes and typography, and ensuring consistency and usability across different devices.",
    title: "UI / UX Design",
    iconComponent: DesignIcon,
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppNavbar, { class: "relative" }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "bg-primary-gray dark:bg-gray-700 cursor-pointer rounded-md border-2 border-r-4 border-b-4 border-[#163537] dark:border-gray-500 text-base md:text-lg font-bold text-[#163537] dark:text-gray-200 py-2.5 px-10 mt-4 w-fit hover:shadow-md hover:scale-105 transition-all"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Get in Touch ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          (imageLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(SkeletonLoader, {
                  type: "image",
                  "image-class": "max-w-[370px] max-h-[300px] w-[370px] md:w-[500px] rounded"
                })
              ]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _imports_0,
                alt: "png",
                onLoad: _cache[0] || (_cache[0] = ($event: any) => (imageLoading.value = false)),
                onError: _cache[1] || (_cache[1] = ($event: any) => (imageLoading.value = false)),
                class: "max-w-[370px] max-h-[300px] w-[370px] md:w-[500px]"
              }, null, 32))
        ])
      ]),
      _hoisted_9,
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service) => {
            return (_openBlock(), _createElementBlock("div", {
              key: service.id,
              class: "group relative cursor-pointer overflow-hidden bg-white dark:bg-gray-800 px-6 pt-10 pb-8 shadow-xl ring-1 ring-[#163537] dark:ring-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl sm:max-w-sm sm:rounded-lg sm:px-10"
            }, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(service.iconComponent), { class: "h-10 w-10 text-white transition-all" }))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", _hoisted_19, _toDisplayString(service.title), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("p", null, _toDisplayString(service.description), 1)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(TechStack),
      _createVNode(StatisticsComp),
      _createVNode(ProjectComp),
      _createVNode(TestimonialsComp),
      _createVNode(ContactForm)
    ]),
    _createVNode(AppFooter)
  ], 64))
}
}

})